var map = {
	"./App.vue": [
		34
	],
	"./components/Aside.vue": [
		36
	],
	"./components/Breadcrumb.vue": [
		37
	],
	"./components/Callout.vue": [
		38
	],
	"./components/DataTable.vue": [
		165,
		19
	],
	"./components/Footer.vue": [
		39
	],
	"./components/Header.vue": [
		40
	],
	"./components/Modal.vue": [
		166,
		18
	],
	"./components/PaginationLinks.vue": [
		167,
		27
	],
	"./components/Sidebar.vue": [
		41
	],
	"./components/SidebarFooter.vue": [
		42
	],
	"./components/SidebarForm.vue": [
		48
	],
	"./components/SidebarHeader.vue": [
		49
	],
	"./components/SidebarMinimizer.vue": [
		50
	],
	"./components/SidebarNavDropdown.vue": [
		51
	],
	"./components/SidebarNavItem.vue": [
		55
	],
	"./components/SidebarNavLink.vue": [
		52
	],
	"./components/SidebarNavTitle.vue": [
		53
	],
	"./components/Spinner.vue": [
		164,
		17
	],
	"./components/Switch.vue": [
		22
	],
	"./containers/Full.vue": [
		35
	],
	"./views/BaseInstituciones.vue": [
		168,
		25
	],
	"./views/Panel.vue": [
		169,
		24
	],
	"./views/Salir.vue": [
		170,
		23
	],
	"./views/pages/ComingSoon.vue": [
		171,
		22
	],
	"./views/pages/Login.vue": [
		172,
		3
	],
	"./views/pages/Page404.vue": [
		173,
		21
	],
	"./views/pages/Page500.vue": [
		174,
		20
	],
	"./views/pages/alumnos/Index.vue": [
		175,
		16
	],
	"./views/pages/alumnos/Ingreso.vue": [
		176,
		9
	],
	"./views/pages/alumnos/Lista.vue": [
		177,
		8
	],
	"./views/pages/contenidos/Formulario.vue": [
		178,
		2
	],
	"./views/pages/contenidos/Index.vue": [
		179,
		15
	],
	"./views/pages/contenidos/Lista.vue": [
		180,
		6
	],
	"./views/pages/docentes/Index.vue": [
		181,
		14
	],
	"./views/pages/docentes/Lista.vue": [
		182,
		7
	],
	"./views/pages/instituciones/Index.vue": [
		183,
		13
	],
	"./views/pages/instituciones/Lista.vue": [
		184,
		12
	],
	"./views/pages/libros/Formulario.vue": [
		185,
		1
	],
	"./views/pages/libros/Index.vue": [
		186,
		11
	],
	"./views/pages/libros/Lista.vue": [
		187,
		5
	],
	"./views/pages/seriales/Formulario.vue": [
		188,
		0
	],
	"./views/pages/seriales/Index.vue": [
		189,
		10
	],
	"./views/pages/seriales/Ingreso.vue": [
		190,
		26
	],
	"./views/pages/seriales/Lista.vue": [
		191,
		4
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 158;
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src lazy ^\.\/.*\.vue$
// module id = 158
// module chunks = 29